import { CheckmarkIcon, Typography } from '@ag1/ui';
import React from 'react';
import { useProductStore } from 'state/store/pdpStore';
import { useStoreCurrency } from 'state/hooks/useStoreCurrency';
import {
  getCurrentPriceMetafield,
  getOriginalPriceMetafield
} from '@portal/shared/utils/shop/bundle/metafields';
import styles from './BundlePriceInfo.module.scss';

type BundlePriceInfoProps = {
  id: string;
  bundlePriceText?: string;
  addSuperScript?: boolean;
};

const BundlePriceInfo = ({ id, bundlePriceText, addSuperScript = false }: BundlePriceInfoProps) => {
  const { symbolCurrency } = useStoreCurrency();
  const bundleVariant = useProductStore((state) => state.bundleVariant);
  const bundleData = useProductStore((state) => state.bundleData);

  const { bundleAssurances, bundleSavingsAmount, bundleSavingsLabel } = bundleVariant || {};
  const originalPrice = bundleData && getOriginalPriceMetafield(bundleData)?.value;
  const discountedPrice = bundleData && getCurrentPriceMetafield(bundleData)?.value;

  return (
    <div id={id} className={styles.root}>
      <ul className={bundleAssurances ? styles.assurancesList : styles.pricingBorder}>
        {bundleAssurances?.map((assurance) => (
          <li key={assurance} className={styles.iconTextWrapper}>
            <span className={styles.iconCheck}>
              <CheckmarkIcon />
            </span>
            <Typography variant="body" size="2" noPadding className={styles.assurance}>
              {assurance}
            </Typography>
          </li>
        ))}
      </ul>
      <div className={styles.priceWrapper}>
        <Typography variant="subtitle" size="2" weight="700" noPadding className={styles.price}>
          {`${discountedPrice} ${bundlePriceText}`}
        </Typography>
        {originalPrice && (
          <Typography variant="subtitle" size="2" noPadding className={styles.oldPrice}>
            {originalPrice}
            {addSuperScript && <sup className={styles.priceSuper}>†</sup>}
          </Typography>
        )}
        {Boolean(bundleSavingsAmount?.trim()) && Boolean(bundleSavingsLabel?.trim()) && (
          <Typography variant="subtitle" size="2" weight="700" noPadding className={styles.savings}>
            {`${symbolCurrency}${bundleSavingsAmount} ${bundleSavingsLabel}`}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default BundlePriceInfo;
